import { Box, styled } from "@mui/material";

export const GetUsernameButtonWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  "&  .MuiBox-root": {
    flexBasis: "501px",
  },
}));

export const StyledForgotUsernameBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(3),
  },
}));
